import bulkOrders from "./bulkOrders/getters";

export default {
  ...bulkOrders,
};
